module.exports = __webpack_public_path__ + "la.3d622932.svg";